// extracted by mini-css-extract-plugin
module.exports = {"desktop":"pca-R7RIqPsebIepRz9ad","mobile":"_2rH_PLB4SD5mWuVYDLBa6Y"};